<template>
<!-- <div style="overflow-x: hidden;overflow-y: hidden;"> -->
  <div id="app">
    <router-view/>
  </div>
<!-- </div> -->
</template>

<script>
export default {
  name: 'App'
}
</script>




// WEBPACK FOOTER //
// src/App.vue